import { BidContractsTableV2 } from "src/components/bid-contracts/BidContractsTableV2";
import { PageHeader } from "src/routes/layout/PageHeader";

export function ProjectBidContractsPage() {
  return (
    <>
      <PageHeader title="Bid Contracts" />
      <BidContractsTableV2 />
    </>
  );
}
